import { indexTopics } from '@/mocks/homepage';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          按主题分类浏览网红爆料内容，快速找到你关心的内幕
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {indexTopics.map((topic) => (
            <a
              key={topic.id}
              href={`#${topic.id}`}
              className="group bg-background-50 border border-background-200 rounded-xl p-5 hover:border-primary-300 transition-all cursor-pointer flex items-start gap-4"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${topic.icon} text-lg text-accent-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{topic.title}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}篇</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{topic.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}